import { Colors } from '../color/Colors';

export const CUSTOM_THEME_NAME = 'app-dark';

export const defineAppTheme = (monaco: any) => {
  monaco.editor.defineTheme(CUSTOM_THEME_NAME, {
    base: Colors.paletteMode === 'light' ? 'vs' : 'vs-dark',
    inherit: true,
    rules: [],
    colors: {
      'editor.background': Colors.bgCode,
      'editorGutter.background': Colors.bgCode,
    },
  });
};
